import Navbar from "../navbar/Navbar"
import { Outlet } from "react-router-dom"

const Layout = () => {

  return (

    <div className="layout">

      <Navbar />
      <main style={{ padding: "10px" }}>
        <Outlet />
      </main>

    </div>

  )

}
export default Layout